"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = /*#__PURE__*/ (0, vue_2.createElementVNode)("h2", { class: "uppercase text-3xl sm:text-6xl font-black tracking-tight leading-squished mb-5" }, "Enquire", -1);
const _hoisted_2 = ["href"];
const _hoisted_3 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "Free Spanish test", -1);
const _hoisted_4 = /*#__PURE__*/ (0, vue_2.createElementVNode)("hr", { class: "my-10 border-yellow-500 border-t-[3px]" }, null, -1);
const _hoisted_5 = { key: 0 };
const _hoisted_6 = /*#__PURE__*/ (0, vue_2.createElementVNode)("h1", { class: "text-left text-4xl md:text-[42px] font-black uppercase leading-squished mb-5" }, "We got your message", -1);
const _hoisted_7 = /*#__PURE__*/ (0, vue_2.createElementVNode)("p", null, "Thanks for getting in touch! One of our team will get back to you soon.", -1);
const _hoisted_8 = ["onClick"];
const _hoisted_9 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "Close", -1);
const _hoisted_10 = ["onSubmit"];
const _hoisted_11 = /*#__PURE__*/ (0, vue_2.createElementVNode)("input", {
    type: "hidden",
    name: "type",
    value: "enquiry"
}, null, -1);
const _hoisted_12 = {
    key: 0,
    class: "px-5 py-2 rounded-3xl bg-red flex items-center gap-5 my-5"
};
const _hoisted_13 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "w-2 h-full rounded-md flex-shrink-0 bg-red" }, null, -1);
const _hoisted_14 = { class: "flex-auto" };
const _hoisted_15 = /*#__PURE__*/ (0, vue_2.createElementVNode)("p", { class: "font-semibold leading-snug text-beige-100" }, " Error ", -1);
const _hoisted_16 = { class: "leading-snug text-beige-100" };
const _hoisted_17 = { class: "mb-5" };
const _hoisted_18 = /*#__PURE__*/ (0, vue_2.createElementVNode)("label", {
    for: "enquiryName",
    class: "label"
}, "Contact Name", -1);
const _hoisted_19 = { class: "grid grid-cols-1 md:grid-cols-2 gap-5 mb-5" };
const _hoisted_20 = /*#__PURE__*/ (0, vue_2.createElementVNode)("label", {
    for: "enquiryEmail",
    class: "label"
}, "Email", -1);
const _hoisted_21 = /*#__PURE__*/ (0, vue_2.createElementVNode)("label", {
    for: "enquiryPhone",
    class: "label"
}, "Contact Number (optional)", -1);
const _hoisted_22 = { class: "mb-5" };
const _hoisted_23 = /*#__PURE__*/ (0, vue_2.createElementVNode)("label", {
    for: "enquiryMessage",
    class: "label",
    required: ""
}, "Enquiry", -1);
const _hoisted_24 = ["disabled"];
const _hoisted_25 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "Send Enquiry", -1);
const vue_3 = require("vue");
const BodyText_vue_1 = __importDefault(require("../BodyText.vue"));
const ButtonIcon_vue_1 = __importDefault(require("../ButtonIcon.vue"));
const Settings_1 = __importDefault(require("../../src/api/Settings"));
const get_1 = __importDefault(require("lodash/get"));
const Route_1 = __importDefault(require("../../src/Route"));
const Forms_1 = __importDefault(require("../../src/api/Forms"));
const Alerts_1 = require("../../stores/Alerts");
const AlertType_1 = require("../../src/types/AlertType");
exports.default = (0, vue_1.defineComponent)({
    __name: 'EnquiryForm',
    props: {
        showTestLink: null
    },
    emits: ['close'],
    setup(__props, { emit }) {
        const props = __props;
        const alertStore = (0, Alerts_1.useAlertsStore)();
        const name = (0, vue_3.ref)('');
        const email = (0, vue_3.ref)('');
        const phone = (0, vue_3.ref)('');
        const message = (0, vue_3.ref)('');
        const intro = (0, vue_3.ref)('');
        let formLoading = (0, vue_3.ref)(false);
        let formError = (0, vue_3.ref)(false);
        let formSuccess = (0, vue_3.ref)(false);
        let errorMessage = (0, vue_3.ref)('');
        function close() {
            emit('close');
        }
        function onSubmit() {
            formError.value = false;
            formLoading.value = true;
            let form = {
                type: 'enquiry',
                name: name.value,
                email: email.value,
                phone: phone.value,
                message: message.value,
            };
            Forms_1.default.submit(form).then((response) => {
                formSuccess.value = true;
                formLoading.value = false;
            }).catch((error) => {
                alertStore.add({
                    type: AlertType_1.AlertType.Error,
                    message: error.message,
                    key: 'add-to-basket',
                });
                formError.value = true;
                formLoading.value = false;
                errorMessage.value = error.message;
                console.error(error);
            });
        }
        Settings_1.default.fetch('enquiry_form_content').then((data) => {
            intro.value = (0, get_1.default)(data, 'enquiry_form_content.content');
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", null, [
                _hoisted_1,
                (0, vue_2.createVNode)(BodyText_vue_1.default, {
                    class: "mb-5",
                    innerHTML: intro.value
                }, null, 8, ["innerHTML"]),
                (0, vue_2.createElementVNode)("a", {
                    href: (0, vue_2.unref)(Route_1.default)('proficiency-tests.current'),
                    class: "button button-outlined text-mutedpurple-800 button-coral-500 hover:button-coral-400 has-icon"
                }, [
                    (0, vue_2.createVNode)(ButtonIcon_vue_1.default),
                    _hoisted_3
                ], 8, _hoisted_2),
                _hoisted_4,
                ((0, vue_2.unref)(formSuccess))
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_5, [
                        _hoisted_6,
                        _hoisted_7,
                        (0, vue_2.createElementVNode)("div", null, [
                            (0, vue_2.createElementVNode)("button", {
                                type: "button",
                                class: "button button-outlined has-icon",
                                onClick: (0, vue_2.withModifiers)(close, ["prevent"])
                            }, [
                                (0, vue_2.createVNode)(ButtonIcon_vue_1.default),
                                _hoisted_9
                            ], 8, _hoisted_8)
                        ])
                    ]))
                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("form", {
                        key: 1,
                        action: "#",
                        onSubmit: (0, vue_2.withModifiers)(onSubmit, ["prevent"])
                    }, [
                        _hoisted_11,
                        ((0, vue_2.unref)(formError))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_12, [
                                _hoisted_13,
                                (0, vue_2.createElementVNode)("span", _hoisted_14, [
                                    _hoisted_15,
                                    (0, vue_2.createElementVNode)("p", _hoisted_16, (0, vue_2.toDisplayString)((0, vue_2.unref)(errorMessage)), 1)
                                ])
                            ]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createElementVNode)("div", _hoisted_17, [
                            _hoisted_18,
                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                id: "enquiryName",
                                name: "name",
                                type: "text",
                                class: "input w-full",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((name).value = $event)),
                                required: ""
                            }, null, 512), [
                                [vue_2.vModelText, name.value]
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_19, [
                            (0, vue_2.createElementVNode)("div", null, [
                                _hoisted_20,
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    id: "enquiryEmail",
                                    name: "email",
                                    type: "email",
                                    class: "input w-full",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((email).value = $event)),
                                    required: ""
                                }, null, 512), [
                                    [vue_2.vModelText, email.value]
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("div", null, [
                                _hoisted_21,
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    id: "enquiryPhone",
                                    name: "phone",
                                    type: "text",
                                    class: "input w-full",
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((phone).value = $event))
                                }, null, 512), [
                                    [vue_2.vModelText, phone.value]
                                ])
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_22, [
                            _hoisted_23,
                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("textarea", {
                                name: "message",
                                id: "enquiryMessage",
                                cols: "30",
                                rows: "10",
                                class: "input w-full",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((message).value = $event))
                            }, null, 512), [
                                [vue_2.vModelText, message.value]
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", null, [
                            (0, vue_2.createElementVNode)("button", {
                                type: "submit",
                                class: "button button-outlined has-icon disabled:opacity-25",
                                disabled: (0, vue_2.unref)(formLoading)
                            }, [
                                (0, vue_2.createVNode)(ButtonIcon_vue_1.default),
                                _hoisted_25
                            ], 8, _hoisted_24)
                        ])
                    ], 40, _hoisted_10))
            ]));
        };
    }
});
